<template>
  <control-base
    :config="conf"
    :dataType="dataType"
    :parentName="$options.name"
    @loaded="$emit('loaded', $event)"
    ref="base"
  >
    <template v-slot:filters>
      <drop-down
        class="w-full"
        :options="agentProperties"
        :selected="conf.selectedProperty"
        subProp="name"
        @updateOption="selectItem"
        :placeholder="'Select a property'"
        :closeOnOutsideClick="true"
      />
      <div>
        <p>Override Text:</p>
        <input v-model="conf.overrideText" />
      </div>
    </template>
    <template v-slot:control>
      <div class="stat-container" ref="container">
        <b class="header">
          <span v-multi-ref:resize>{{ displayText }}</span>
        </b>
        <b id="stat" style="text-align: center" class="stat"
          ><span v-multi-ref:resize>{{ value }}</span></b
        >
      </div>
    </template>
  </control-base>
</template>

<script>
export default {
  name: "AgentsInState",

  props: {
    config: {
      required: true,
      value: Object,
    },

    shouldResize: {
      required: false,
      value: Boolean,
    },
  },

  data() {
    return {
      dataType: "agent",
      agentProperties: [],
    };
  },

  watch: {
    shouldResize() {
      if (this.shouldResize) {
        this.$nextTick(function () {
          this.resize();
        });
      }
    },
  },

  mounted() {
    this.registerDependencies();

    this.agentProperties = [
      {name: "TotalAgents", value: -1},
      ...this.$constants.AgentStates
    ]

    setTimeout(() => this.$nextTick(() => this.resize()), 1000);
  },

  updated() {
    this.$nextTick(function () {
      this.resize();
    });
  },

  computed: {
    conf() {
      return this.config;
    },

    layoutLocked() {
      return this.$store.getters.locked;
    },

    filteredAgents() {
      var agents = this.$store.getters.agentData;
      return agents.filter(
        (x) =>
          this.conf.campaignNames.includes(x.campaign) &&
          !x.agentName.startsWith("Robot") &&
          this.agentProperties.map(z=>z.value).includes(x.agentStateNum)
      );
    },

    value() {
      if (this.conf.selectedProperty.value == -1) {
        return this.filteredAgents.filter(x=>x.agentStateNum >= 2).length;
      }
      return this.filteredAgents.filter(
        (x) => x.agentStateNum == this.conf.selectedProperty.value
      ).length;
    },

    displayText() {
      return this.conf.overrideText
        ? this.conf.overrideText
        : this.conf.selectedProperty.name;
    },
  },

  methods: {
    registerDependencies() {
      this.$store.getters.agentArgs.addProperty("AgentStateNum");
    },

    selectItem(item) {
      this.conf.selectedProperty = item;
      this.resize();
    },

    resize() {
      this.resizeText({elements: this.$refs.resize})
      this.$emit("resized");
    },
  },
};
</script>

<style scoped>
.stat-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-radius: inherit;
}

.header {
  height: 30%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat {
  height: 70%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 700;
}
</style>